/**
 * Logs the captured error into console and throw forward to Sentry.
 *
 * @param {Error} error
 * @return {void}
 */

import { isLocalhost } from "@/utils/debug/is-dev";

export const captureException = (error) => {
  // if (typeof window.errorCollection === "undefined") window.errorCollection = [];
  // window.errorCollection.push(error);

  if (isLocalhost) {
    return console.error(error instanceof Error ? error.message : error);
  }

  if (!(error instanceof Error)) return;

  try {
    // @ts-ignore
    Sentry.captureException(error);
  } catch (error) {
    console.error(error);
  }
}
